import useModal from 'lib/hooks/useModal';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

import PreAuthRiderView from './PreAuthRiderView';

const AuthorizationAndConsent = () => {
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <div className="flex items-start gap-2 rounded-lg border border-solid border-primary-200 bg-primary-25 p-3">
      <Icon icon="info-circle-filled" color="primary" size={16} />
      <div className="flex flex-col gap-2">
        <Typography variant="p" size="xs" weight="medium" className="w-full">
          Authorization & consent
        </Typography>
        <Typography variant="p" size="xs" className="!block w-full">
          I authorize secure storage and use of my card on file for approved healthcare transactions
          under the Addendum for
          <button
            onClick={openModal}
            type="button"
            className="cursor-pointer text-primary-600 underline">
            Pre-Authorized Healthcare Transactions (“Click for full Rider”)
          </button>
          and applicable card-brand rules. This includes any applicable charges and refunds as
          outlined. All transactions are processed through HIPAA-compliant and PCI-DSS certified
          systems for the protection of my health and payment information. <br />
          Our practice is committed to transparent cost communication, secure payment handling, and
          flexible payment options supporting continued access to care.
        </Typography>
      </div>
      <PreAuthRiderView isOpen={isOpen} handleClose={closeModal} />
    </div>
  );
};

export default AuthorizationAndConsent;
